import React from 'react';
import { Link } from 'react-router';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import classes from '../../profile-links.scss';
export const OtherProfileLinks = ({
  passwordNotSet
}) => {
  return /*#__PURE__*/React.createElement(Link, {
    to: APP_ROUTES.PROFILE_PASSWORD,
    className: classes.link,
    activeClassName: classes.active,
    "data-tab": "ChangePassword"
  }, passwordNotSet ? 'Set Password' : 'Change Password');
};